export const getSearchResults = (state) => state.search.results;
export const getSearchFacets = (state) => state.search.facets;
export const getSearchKey = (state) => state.search.key;
export const getSearchQueryParams = (state) => state.search.queryParams;
